import classnames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { cacheSortColumn } from "src/searchCache/actions";
import { State } from "src/state";
import { updateSort } from "./actions";
import DownArrow from "./descending.svg";
import { getBriefSpreadSort } from "./selector";
import { SPREAD_COLUMNS, SpreadSort } from "./types";

export interface DocumentsListColumnHeaderProps {
  spreadColumn: SPREAD_COLUMNS;
  spreadSort: SpreadSort;
  className?: string;
  updateSortFunc: typeof updateSort;
  cacheSortColumnFunc: typeof cacheSortColumn;
}

export const DocumentsListColumnHeader: React.SFC<
  DocumentsListColumnHeaderProps
> = ({ spreadColumn, spreadSort, className, updateSortFunc, cacheSortColumnFunc }) => {
  const changeSort = () => {
    updateSortFunc(spreadColumn);
    cacheSortColumnFunc(spreadColumn)
  };

  return (
    <div className={className} onClick={changeSort}>
      {spreadColumn}
      {spreadSort.sortColumn === spreadColumn && (
        <img
          className={classnames("arrowDown", {
            arrowUp: spreadSort.sortAscending
          })}
          src={DownArrow}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: State) => ({
  spreadSort: getBriefSpreadSort(state)
});

export default connect(
  mapStateToProps,
  { updateSortFunc: updateSort, cacheSortColumnFunc: cacheSortColumn }
)(DocumentsListColumnHeader);



// WEBPACK FOOTER //
// ./src/documentList/DocumentsListColumnHeader.tsx